import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const Container = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: ${({ $isShowPlayer }) =>
    $isShowPlayer ? "calc(90px + 16px)" : "16px"};
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 24px;
  margin: auto;
  max-width: 570px;
  width: 100%;
  padding: 12px 16px;
  color: white;
  background-color: rgba(59, 59, 59, 1);
  border-radius: 12px;

  @media ${breakpoints.sm} {
    bottom: ${({ $isShowPlayer }) =>
      /* 134px - высота плеера на мобилке */
      $isShowPlayer ? "calc(134px + 16px)" : "16px"};
  }

  @media ${breakpoints.xs} {
    gap: 16px;
    flex-direction: column;
    width: calc(100% - 40px);
    align-items: flex-start;
  }

  a {
    color: var(--orange-primary);
  }
`;
